/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_SOURCESANSPRO_BOLD: 'SourceSansProBold, sans-serif',
  FONT_ALEGREYASANS_BOLD: 'AlegreyaSansBold, sans-serif',
  FONT_ALEGREYASANS_MEDIUM: 'AlegreyaSansMedium, sans-serif',
  FONT_ALEGREYASANS_REGULAR: 'AlegreyaSansRegular, sans-serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_500: '500',
  //Mobile values
  //H1
  FONT_SIZE_H1: '40px',
  LINE_HEIGHT_H1: '46px',
  LETTER_SPACING_H1: '1.6px',
  //H2
  FONT_SIZE_H2: '27px',
  LINE_HEIGHT_H2: '34px',
  LETTER_SPACING_H2: '1.62px',
  //H3
  FONT_SIZE_H3: '23px',
  LINE_HEIGHT_H3: '30px',
  LETTER_SPACING_H3: '0.69px',
  //H4
  FONT_SIZE_H4: '19px',
  LINE_HEIGHT_H4: '20px',
  LETTER_SPACING_H4: '0.38px',
  //H5
  FONT_SIZE_H5: '13px',
  LINE_HEIGHT_H5: '16px',
  LETTER_SPACING_H5: '0.13px',
  //P
  FONT_SIZE_P: '16px',
  LINE_HEIGHT_P: '28px',
  LETTER_SPACING_P: '0.16px',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '70px',
    LINE_HEIGHT_H1: '76px',
    LETTER_SPACING_H1: '3.5px',
    //H2
    FONT_SIZE_H2: '34px',
    LINE_HEIGHT_H2: '48px',
    LETTER_SPACING_H2: '0.68px',
    //H3
    FONT_SIZE_H3: '28px',
    LINE_HEIGHT_H3: '40px',
    LETTER_SPACING_H3: '0.56px',
    //H4
    FONT_SIZE_H4: '19px',
    LINE_HEIGHT_H4: '23px',
    LETTER_SPACING_H4: '0.76px',
    //H5
    FONT_SIZE_H5: '14px',
    LINE_HEIGHT_H5: '17px',
    LETTER_SPACING_H5: '0.28px',
    //P
    FONT_SIZE_P: '18px',
    LINE_HEIGHT_P: '28px',
    LETTER_SPACING_P: '0.18px'
  },
  FONT_FACES: ['SourceSansProBold', 'AlegreyaSansBold', 'AlegreyaSansMedium', 'AlegreyaSansRegular']
};